'use client';

import './ExteriorInterior.scss';
import Button from '../../ui/Button/Button';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import React, { useState, useMemo, useEffect, useRef } from 'react';
import CarModelDetails from '../CarDetails/CarModelDetails';

export default function ExteriorInterior({ fields }) {
  // 添加组件实例标识
  const componentId = Math.random().toString(36).substr(2, 9);

  // 检查是否有 item 数据
  const items = fields?.item || [];

  // 如果没有数据，显示原来的按钮样式
  if (!items || items.length === 0) {
    return <div className={'container car-model-ExteriorInterior'}>No data</div>;
  }

  // 按照 DownloadCarInfo 的模式处理数据，使用数组索引
  const processedData = useMemo(() => {
    return items.map((item, index) => ({
      ...item,
      index,
    }));
  }, [items]);

  // 状态管�?
  const [currentItem, setCurrentItem] = useState(
    processedData.length > 0 ? processedData[0] : null
  );
  const prevProcessedDataRef = useRef(processedData);

  useEffect(() => {
    // 深度比较函数（简化版
    const isDataChanged = (prev, current) => {
      return JSON.stringify(prev) !== JSON.stringify(current);
    };
    if (processedData.length > 0) {
      // 仅当 processedData 内容实际变化时更新
      if (isDataChanged(prevProcessedDataRef.current, processedData)) {
        const latestItem = processedData.find((item) => item.index === currentItem?.index);
        if (latestItem) {
          // 避免不必要的更新：比较内容差异
          if (
            JSON.stringify(currentItem) !==
            JSON.stringify({
              ...latestItem,
              _syncKey: currentItem?._syncKey,
            })
          ) {
            setCurrentItem({
              ...latestItem,
              _syncKey: Date.now(), // 确保新引用
            });
          }
        } else if (currentItem) {
          // 当前项不存在于新数据中时，回退到第一项
          setCurrentItem(processedData[0]);
        }
        prevProcessedDataRef.current = processedData;
      }
    } else if (currentItem) {
      // 数据变为空时清除选中状态
      setCurrentItem(null);
    }
  }, [processedData, currentItem?.index]);

  // 处理菜单点击
  const handleMenuClick = (index) => {
    const selectedItem = processedData.find((el) => el.index === index) || currentItem;

    setCurrentItem({ ...selectedItem, timestamp: new Date().getTime() });
  };

  // 生成菜单项数�?
  const menuItems = processedData.map((item) => ({
    title: item.fields?.title?.value || item.displayName || `Item ${item.index}`,
    index: item.index,
  }));

  // 使用 useMemo 优化数据准备，避免重复计�?
  const preparedData = useMemo(() => {
    if (!currentItem || !currentItem.fields) return null;

    // 通过 ExteriorInterior 传递时隐藏 title
    const { title, ...otherFields } = currentItem.fields;

    const result = {
      ...otherFields,
      // 设置 title 为空对象，这�?CarModelDetails 就不会显示标�?
      title: {},
    };

    return result;
  }, [currentItem, componentId]);

  // 安全检�?currentItem
  if (!currentItem || currentItem.index === undefined) {
    return <div className={'container car-model-ExteriorInterior'}>Loading...</div>;
  }

  // 调试：显示当前选中�?item

  return (
    <div className={'container car-model-ExteriorInterior'} data-component-id={componentId}>
      <div className={'wrapper'} data-aos="fade-up">
        {/* 一级菜单切�?*/}
        <div className={'segmented-menu'} data-aos="fade-up">
          <div className={'toggle'}>
            <div className={'inner'}>
              {menuItems.map((item) => (
                <div
                  key={item.index}
                  role="presentation"
                  className={'item'}
                  onClick={() => handleMenuClick(item.index)}
                  style={{
                    color: item.index === currentItem.index ? '#121212' : '#828282',
                  }}
                >
                  {item.title}
                </div>
              ))}
              <div
                className={'slicer'}
                style={{
                  transform: `translateX(${currentItem.index * 100}%)`,
                  width: `${100 / menuItems.length}%`,
                }}
              />
            </div>
          </div>
        </div>

        {/* 显示对应�?CarDetails 组件 */}
        {currentItem && preparedData && (
          <div
            className={'car-details-container'}
            data-component-id={componentId}
            data-exterior-interior="true"
          >
            <CarModelDetails fields={preparedData} />
          </div>
        )}
      </div>
    </div>
  );
}
